import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationMethodType, PollResponse } from '../../../backend/model';
import { AuthenticationContextDatasourceService } from '../../../backend/datasource';
import { UserAgentUtil } from '../../util';
import { timer } from 'rxjs';
import { FrejaEidAuthenticationTicket } from '../../../backend/model/freja-eid-authentication-ticket';
import { FrejaEidOrgService } from '../../../backend/api/freja-org.service';
import { FrejaEidOrgPollingService } from '../../../backend/datasource/freja-org-polling.service';
import { ThemeHandlerService } from '../../service/theme-handler.service';
import { Theme } from '../../../backend/model/theme.model';
import { LoadingSpinnerComponent } from '../../../shared/component/loading-spinner/loading-spinner.component';
import { IDCardModule } from '@inera/ids-angular/components/card';
import { IDLinkModule } from '@inera/ids-angular/components/link';
import { NgTemplateOutlet } from '@angular/common';
import { ThemeType } from '../../../backend/model/theme-type';

@Component({
  selector: 'freja-eid-org-authentication',
  imports: [LoadingSpinnerComponent, IDCardModule, IDLinkModule, NgTemplateOutlet],
  templateUrl: './freja-eid-org-authentication.component.html',
  styleUrls: ['./freja-eid-org-authentication.component.scss']
})
export class FrejaEidOrgAuthenticationComponent implements OnInit {
  private authenticationContextDatasource = inject(AuthenticationContextDatasourceService);
  private frejaEidOrgPollingService = inject(FrejaEidOrgPollingService);
  private frejaEidOrgService = inject(FrejaEidOrgService);
  private themeHandler = inject(ThemeHandlerService);

  public base64Prefix = 'data:image/jpeg;base64,';
  public ticket: FrejaEidAuthenticationTicket;
  public pending = false;
  public qrToken = null;
  public qrTokenB64 = null;
  public displayQrCode = true;

  public isSameDevice = false;
  public isAndroid = false;
  public isStarting = false;

  public theme: Theme;
  public themeType = ThemeType;
  public clientInfo;

  ngOnInit(): void {
    this.isSameDevice =
      this.authenticationContextDatasource.getAuthMethodType() === AuthenticationMethodType.FREJA_EID_ORG_SAME_DEVICE;

    this.themeHandler.getTheme().subscribe(theme => {
      this.theme = theme.value.value;
    });

    this.clientInfo = this.authenticationContextDatasource.getClientInfo();

    this.getTicket();

    this.isAndroid = UserAgentUtil.isAndroid();
  }

  public getMethodTypeText(): string {
    return this.authenticationContextDatasource.getIsSignature() ? 'underskriften' : 'inloggningen';
  }

  public cancelAuthentication(): void {
    this.frejaEidOrgService.cancelAuthentication(
      this.authenticationContextDatasource.getSessionId(),
      this.authenticationContextDatasource.getIdp()
    );
  }

  public getTypeText(): string {
    return this.authenticationContextDatasource.getIsSignature() ? 'Jag signerar hos' : 'Jag legitimerar mig hos';
  }

  public manualAutostart(): void {
    this.displayQrCode = false;
    this.autoStart(true);
  }

  public isSingleMethod(): boolean {
    return this.authenticationContextDatasource.getIsSingleMethod();
  }

  private getTicket(): void {
    this.frejaEidOrgService
      .authenticationRequest(
        this.authenticationContextDatasource.getAuthMethodType(),
        this.authenticationContextDatasource.getSessionId(),
        this.authenticationContextDatasource.getIdp()
      )
      .subscribe(ticket => {
        console.log('ticket', ticket);
        this.ticket = ticket;
        this.frejaEidOrgService.setTicket(this.ticket);

        if (ticket.qrStartTokenCodeB64) {
          this.qrTokenB64 = ticket.qrStartTokenCodeB64;
        } else {
          this.qrToken = ticket.autoStartToken;
        }

        this.startPoll();

        if (!this.isAndroid || (this.isAndroid && !this.authenticationContextDatasource.getIsSingleMethod())) {
          this.autoStart(false);
        }
      });
  }

  private autoStart(manualAutoStart: boolean): void {
    if (this.isSameDevice || manualAutoStart) {
      this.tryStart();
    }
  }

  private tryStart(): void {
    if (this.isStarting === true) {
      return;
    }

    this.isStarting = true;

    timer(3000).subscribe(() => {
      this.isStarting = false;
    });
    window.location.href = this.ticket.autoStartToken;
  }

  private startPoll(): void {
    this.frejaEidOrgPollingService.connect(this.authenticationContextDatasource.getSessionId()).subscribe(response => {
      if (this.evaluateIfStartedOrCompleted(response)) {
        if (response?.redirectUrl?.length) {
          window.location.href = response.redirectUrl;
        } else {
          this.pending = true;
        }
      } else {
        if (response?.qrStartTokenCodeB64?.length) {
          this.qrTokenB64 = response.qrStartTokenCodeB64;
        }
      }
    });
  }

  private evaluateIfStartedOrCompleted(data: PollResponse): boolean {
    return data !== null && (data.statusCode === 'DELIVERED_TO_MOBILE' || data.statusCode === 'APPROVED');
  }
}
